import FormattedInput from "./FormattedInput.vue";
import Vue from "vue";
export default Vue.extend({
    props: {
        formatError: {
            default: "Must be a number",
        },
        required: {
            type: Boolean,
            default: false,
        },
        suffixText: {
            required: true,
            type: String,
        },
    },
    components: { FormattedInput },
    computed: {
        customRules() {
            return this.$attrs.rules || [];
        },
    },
    methods: {
        validateNumberRule() {
            const currentValue = this.$attrs.value;
            if (!this.required && currentValue == undefined) {
                return true;
            }
            const isNumber = /^[0-9]+$/.test(currentValue);
            if (!isNumber) {
                return this.formatError;
            }
            return true;
        },
        formatter(number) {
            return `${number} ${this.suffixText}`;
        },
    },
});
